var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show && _vm.isMyNamePage)?_c('section',{staticClass:"module"},[_c('section',{staticClass:"btn-back",on:{"click":_vm.goback}},[_c('AppIcon',{attrs:{"name":"arrow-left"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }